import { chakra } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import { useColorModeValue } from 'toolkit/chakra/color-mode';
import { Image } from 'toolkit/chakra/image';
// import IconSvg from 'ui/shared/IconSvg';

import { INVERT_FILTER } from './consts';

export type IconName =
  | 'networks/recordercoin-logo-horizontal' |
  'networks/logo-placeholder';

const LogoFallback = () => {
  // const iconName = useColorModeValue(
  //   'logo/uniieq-logo.png',
  //   'networks/recordercoin-logo-horizontal-light',
  // );

  return (
    // <IconSvg
    //   name={ iconName }
    //   // name="networks/logo-placeholder"
    //   width="120px"
    //   height="24px"
    //   color={{ base: 'blue.600', _dark: 'white' }}
    //   aria-label="Network logo placeholder"
    // />
    <Image
      src="/logo/uniieq-logo.png"
      h="24px"
      w="120px"
      alt="Uniieq"
      objectFit="contain"
    />
  );
};

type Props = {
  className?: string;
};

const NetworkLogo = ({ className }: Props) => {

  const logoSrc = useColorModeValue(config.UI.navigation.logo.default, config.UI.navigation.logo.dark || config.UI.navigation.logo.default);

  return (
    <chakra.a
      className={ className }
      href={ route({ pathname: '/' }) }
      aria-label="Link to main page"
    >
      <Image
        h="24px"
        skeletonWidth="120px"
        src={ logoSrc }
        alt={ `${ config.chain.name } network logo` }
        fallback={ <LogoFallback/> }
        filter={{ _dark: !config.UI.navigation.logo.dark ? INVERT_FILTER : undefined }}
        objectFit="contain"
        objectPosition="left"
      />
    </chakra.a>
  );
};

export default React.memo(chakra(NetworkLogo));
